import { Spinner, Toggle } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import useMaesterDisplay from '../../../pages/home/secure/security_posture/EnableMaesterBanner/useMaesterDisplay'

const propTypes = {
  /**
   * Callback to refresh the onboarding checklist data after an action is performed
   */
  refreshOnboardingChecklist: PropTypes.func.isRequired,
}

const defaultProps = {}

function EnableMaesterToggle(props) {
  const { refreshOnboardingChecklist } = props
  const { loading, isMaesterDisplayEnabled, updateMaesterDisplayStatus } = useMaesterDisplay()
  const organizationId = useSelector(({ user }) => user?.data?.organization)

  return loading ? (
    <Spinner size="small" />
  ) : (
    <Toggle
      checked={isMaesterDisplayEnabled}
      onChange={async (value) => {
        await updateMaesterDisplayStatus({ organizationId, enabled: value })
        refreshOnboardingChecklist()
      }}
    />
  )
}

EnableMaesterToggle.propTypes = propTypes
EnableMaesterToggle.defaultProps = defaultProps

export default EnableMaesterToggle
